import React, { useState } from 'react'
import {ReactComponent as Minus} from '@svgs/minus-circle.svg'
import {ReactComponent as Plus} from '@svgs/plus-circle.svg'
import RichText from '@src/components/rich-text'

const FaqAccordion = ({question, answer, questionClassname = '', answerClassname = '', isRichText = false }) => {
  const [opened, setOpened] = useState(false)

  const toggleOpened = () => {
    setOpened(prevState => !prevState)
  }

  return (
    <div className='flex flex-col w-full py-5 border-b-1'>
      <div className={`flex justify-between w-full cursor-pointer ${questionClassname}`} onClick={toggleOpened}>
        <p className='font-medium text-lg font-owners'>
          {question}
        </p>
        {opened ? <Minus className={'flex-shrink-0'} />  : <Plus className={'flex-shrink-0'} />}
      </div>
      
      {opened && (
        <div className={`${opened ? 'pt-2.5 max-h-9999 visible opacity-100' : 'pt-0 max-h-0 invisible opacity-0'} ${answerClassname} text-soft-black !font-owners-text transition-all duration-300`}>
          {React.isValidElement(answer)
            ? answer
            : isRichText && (typeof answer === 'string' || Array.isArray(answer))
              ? <RichText listClassname="pl-5" className="" text={answer} />
              : typeof answer === 'string'
                ? <div dangerouslySetInnerHTML={{ __html: answer }} />
                : null}
        </div>
      )}
    </div>
  )
}

export default FaqAccordion